import InformationTooltipProvider, {
  ICoordinates,
  InformationTooltipContext,
  XPositionType,
} from './Provider'

export { InformationTooltipContext, XPositionType, ICoordinates }
export default InformationTooltipProvider
